<nav class="navbar bg-primary navbar-dark navbar-expand-lg d-none d-lg-flex">
  <a class="navbar-brand py-0" [routerLink]="['/']" routerLinkActive="router-link-active">
    <img class="ms-1 h-100" src="assets/images/home-logo.png" draggable="false" />
  </a>

  <button
    class="navbar-toggler"
    type="button"
    (click)="isCollapsed = !isCollapsed"
    aria-controls="navbarSupportedContent"
    aria-expanded="false"
    aria-label="Toggle navigation"
  >
    <span class="navbar-toggler-icon"></span>
  </button>

  <!-- Left Side Content -->
  <div class="navbar-collapse" [ngbCollapse]="isCollapsed" id="navbarSupportedContent">
    <div class="nav-container">
      <ul class="navbar-nav me-auto" #greedyNav>
        <li class="nav-item active">
          <a class="nav-link mx-1" [routerLink]="['/rewards']" routerLinkActive="router-link-active">{{
            'nav.rewards' | translate
          }}</a>
        </li>
        <li class="nav-item active">
          <a class="nav-link mx-1" [routerLink]="['/challenges']" routerLinkActive="router-link-active">{{
            'nav.challenges' | translate
          }}</a>
        </li>
        <li class="nav-item active">
          <a class="nav-link mx-1" [routerLink]="['/earn']" routerLinkActive="router-link-active">{{ 'nav.earn' | translate }}</a>
        </li>

        <li class="nav-item active">
          <a class="nav-link mx-1" [routerLink]="['/ecash']" routerLinkActive="router-link-active">{{
            'nav.ecash' | translate
          }}</a>
        </li>
      </ul>
    </div>
    <!-- Right Side Content -->
    <div class="d-flex align-items-center flex-nowrap my-2 my-lg-0">
      <div *inPopulation="[populations.GuardianTest]">
        <div *inProductCode="[productcode.PremiumDigitalMember]">
          <fgb-back-to-guardian></fgb-back-to-guardian>
        </div>
      </div>
      <div [routerLink]="['/activity']" class="balance font-size-14 text-primary cursor-pointer me-2">
        <div *ngIf="loyaltyPointsCard$" class="text-white d-flex align-items-center justify-content-center">
          <span class="material-icons font-size-20 pe-2">loyalty</span>
          <span class="fw-bold points"
            >{{ loyaltyPointsCard$ | async | number : '1.0-0' }} {{ 'fgbcl.curreuncy.pts' | translate }}</span
          >
        </div>
      </div>

      <div [routerLink]="['/ecash']" class="balance font-size-14 text-primary cursor-pointer">
        <div *ngIf="combinedCard$" class="text-white d-flex align-items-center justify-content-center">
          <span class="material-symbols-outlined font-size-20 pe-2"> money_bag </span>
          <span class="fw-bold points">{{ combinedCard$ | async | FortressCurrencyPipe }}</span>
        </div>
      </div>

      <div class="notification-button-wrapper">
        <fgb-notification-button />
      </div>

      <div class="member" ngbDropdown #ddAccount="ngbDropdown" [autoClose]="'outside'">
        <button
          class="nav-link btn text-white d-flex align-items-center ms-2 me-3 px-0 justify-content-end"
          id="namedropdown"
          ngbDropdownToggle
          (click)="isCollapsed = !isCollapsed"
        >
          <span class="material-icons-outlined"> dehaze </span>
        </button>
      </div>
    </div>
  </div>
</nav>

<ng-template #memberDetailsLoading>
  <div class="user-box d-block text-center text-on-primary px-4">
    <fgb-loading [size]="'small'"></fgb-loading>
  </div>
</ng-template>

<ng-container *ngIf="isCollapsed">
  <div class="grey-background">
    <div class="d-flex flex-column mobile-nav-menu-content">
      <!-- Close Button -->
      <button class="close-button position-absolute border-0 p-0 bg-white" (click)="isCollapsed = !isCollapsed">
        <i class="material-icons">close</i>
      </button>

      <!-- Club Logo -->
      <div class="d-flex align-items-center justify-content-start brand-logo">
        <img class="brand" src="assets/images/logo.png" draggable="false" />
      </div>

      <div class="modal-content d-flex gap-2">
        <div class="modal-header w-100 d-flex align-items-center justify-content-between mt-3">
          <div class="header-left">
            <div class="card-name text-uppercase font-size-18 font-page-heading" *ngIf="memberDetails$ | async as memberDetails">
              {{ memberDetails.FirstName }} {{ memberDetails.Surname }}
            </div>
            <div class="account-num-header font-sie-14" *ngIf="card$ | async as memberCard">
              <span class="font-size-14">{{ 'barcode.memberid' | translate }} </span>
              <span class="font-size-14">{{ memberCard.ExternalRefNumber }}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="add-card mb-4 mt-3">
        <fgb-add-card-payment (onClickNavigate)="isCollapsed = !isCollapsed" />
      </div>

      <div class="mobile-nav-button-container">
        <!-- Nav Buttons -->
        <a
          class="nav-item"
          [routerLink]="['/']"
          [routerLinkActive]="'active'"
          [routerLinkActiveOptions]="{ exact: true }"
          (click)="isCollapsed = !isCollapsed"
        >
          <div class="content">
            <div class="nav-text">{{ 'nav.home' | translate }}</div>
          </div>
        </a>

        <a
          class="nav-item"
          [routerLink]="['/account']"
          [routerLinkActive]="'active'"
          [routerLinkActiveOptions]="{ exact: true }"
          (click)="isCollapsed = !isCollapsed"
        >
          <div class="content">
            <div class="nav-text">{{ 'nav.account' | translate }}</div>
          </div>
        </a>

        <a
          class="nav-item"
          [routerLink]="['/rewards']"
          [routerLinkActive]="'active'"
          [routerLinkActiveOptions]="{ exact: true }"
          (click)="isCollapsed = !isCollapsed"
        >
          <div class="content">
            <div class="nav-text">{{ 'nav.rewards' | translate }}</div>
          </div>
        </a>

        <a
          class="nav-item"
          [routerLink]="['/challenges']"
          [routerLinkActive]="'active'"
          [routerLinkActiveOptions]="{ exact: true }"
          (click)="isCollapsed = !isCollapsed"
        >
          <div class="content">
            <div class="nav-text">{{ 'nav.challenges' | translate }}</div>
          </div>
        </a>

        <a
          class="nav-item"
          [routerLink]="['/rewards/wallet']"
          [routerLinkActive]="'active'"
          [routerLinkActiveOptions]="{ exact: true }"
          (click)="isCollapsed = !isCollapsed"
        >
          <div class="content">
            <div class="nav-text">{{ 'nav.wallet' | translate }}</div>
          </div>
        </a>

        <a
          class="nav-item"
          [routerLink]="['/earn']"
          [routerLinkActive]="'active'"
          [routerLinkActiveOptions]="{ exact: true }"
          (click)="isCollapsed = !isCollapsed"
        >
          <div class="content">
            <div class="nav-text">{{ 'nav.earn' | translate }}</div>
          </div>
        </a>

        <a
          class="nav-item"
          [routerLink]="['/worksheet']"
          [routerLinkActive]="'active'"
          [routerLinkActiveOptions]="{ exact: true }"
          (click)="isCollapsed = !isCollapsed"
        >
          <div class="content">
            <div class="nav-text">{{ 'nav.activity' | translate }}</div>
          </div>
        </a>

        <a
          class="nav-item"
          [routerLink]="['/faq']"
          [routerLinkActive]="'active'"
          [routerLinkActiveOptions]="{ exact: true }"
          (click)="isCollapsed = !isCollapsed"
        >
          <div class="content">
            <div class="nav-text">{{ 'nav.faq' | translate }}</div>
          </div>
        </a>

        <a
          class="nav-item"
          [routerLink]="['/terms']"
          [routerLinkActive]="'active'"
          [routerLinkActiveOptions]="{ exact: true }"
          (click)="isCollapsed = !isCollapsed"
        >
          <div class="content">
            <div class="nav-text">{{ 'nav.terms' | translate }}</div>
          </div>
        </a>

        <a
          class="nav-item"
          [routerLink]="['/contact']"
          [routerLinkActive]="'active'"
          [routerLinkActiveOptions]="{ exact: true }"
          (click)="isCollapsed = !isCollapsed"
        >
          <div class="content">
            <div class="nav-text">{{ 'nav.contact.us' | translate }}</div>
          </div>
        </a>

        <a class="log-out" (click)="logout()">
          <i class="material-icons font-size-14 fw-bold">logout</i>
          <div class="nav-text fw-bold">{{ 'nav.log.out' | translate }}</div>
        </a>
      </div>
    </div>
  </div>
</ng-container>
